<template>
  <div class="m-5 xl:m-15 2xl:m-20">
    <!-- BEGIN Popup compare cartography -->
    <PopupCompareCarto
      :compare-carto="compareCarto"
      @close="closeCompare"
      @changeCompare="
        (index) => {
          changeCompare(index);
        }
      "
      :carto-to-compare="cartoToCompare"
      :history-to-display="historyToDisplay"
      :competences-cles="{}"
      :history-competences-cles="[]"
      :competences-informatique="{}"
      :history-competences-informatique="[]"
      :competences-linguistique="{}"
      :history-competences-linguistique="[]"
      :competences-socio-pro="cartograhiesToDisplay"
      :history-competences-socio-pro="historiesToCompare"
      :competences-pro="{}"
      :history-competences-pro="{}"
      :is-beneficiary="infosPass.id_pass === user.id"
      v-if="compareCarto"
    />
    <!-- END Popup compare cartography -->

    <div v-if="ongoingEvaluation || closedEvaluations">
      <h3 class="mb-10">
        Compétences socio-professionnelles
      </h3>

      <div
        v-for="(pageName, index) in Object.keys(templates).filter(
          (t) => templates[t].length > 0
        )"
        :key="index"
        class="mb-10"
      >
        <!-- BEGIN List modèles de pages -->
        <div class="flex justify-center items-center">
          <div
            class="flex relative cursor-pointer my-8 w-max max-w-7/12"
            @click.stop="displayTemplateList(pageName)"
          >
            <div class="flex flex-row ml-auto items-end">
              <div class="text-indigo-600 font-normal text-xl">
                {{
                  templates[pageName][currentTemplate[pageName]].toUpperCase()
                }}
              </div>
            </div>
            <div
              class="text-pink-600 max-h-8 rounded-full relative flex items-center p-2 order-2"
            >
              <icon
                class="h-4 w-4"
                name="chevron-down"
              />
            </div>
            <div
              class="fieldlist flex z-20 mt-2 top-10 w-max max-w-full right-0 absolute rounded-md bg-white shadow-md shadow-gray-600 text-sm"
              v-if="templateListDisplayed == pageName"
              v-click-outside="closeTemplateList"
              id="compcle"
            >
              <div class="mx-5 my-3">
                <div class="text-left">
                  <div
                    class="first:pt-2 py-1"
                    v-for="(tmp, i) in templates[pageName]"
                    :key="i"
                  >
                    <p
                      class="text-gray-600 hover:text-gray-900"
                      @click.stop="changeTemplate(pageName, i)"
                    >
                      <span>{{ tmp }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END List modèles de pages -->

        <!-- BEGIN all chart for compétences socio pro -->
        <div v-if="cartograhiesToDisplay[pageName]">
          <div
            v-if="shouldBeSplit(cartograhiesToDisplay[pageName])"
            class="flex flex-col w-full gap-6"
          >
            <div
              v-for="[category, current] in getCategories(
                cartograhiesToDisplay[pageName]
              )"
              :key="category"
            >
              <h3 class="text-base">
                {{ category }}
              </h3>
              <radar
                :height="100"
                :id-chart="'compsociopro' + index + '' + category"
                :labels="current?.labels"
                :max="current?.max"
                :values="
                  current?.values?.filter(
                    (v) => v.label != 'Référent' || infosPass.id_pass != user.id
                  )
                "
              />
            </div>
          </div>
          <radar
            v-else
            :key="cartograhiesToDisplay[pageName].date_fin_eval"
            :height="150"
            :id-chart="'compsociopro' + index + ''"
            :labels="cartograhiesToDisplay[pageName]?.labels"
            :max="cartograhiesToDisplay[pageName]?.max"
            :values="
              cartograhiesToDisplay[pageName]?.values?.filter(
                (v) => v.label != 'Référent' || infosPass.id_pass != user.id
              )
            "
          />
        </div>

        <!-- END all chart for compétences socio pro -->

        <!-- BEGIN Compare button -->
        <div
          class="mt-8 w-full text-center flex justify-center"
          v-if="$can(constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE)"
        >
          <action-button
            class="py-2"
            border-color="transparent"
            text-color="text-white"
            bg-color="bg-pink-600"
            libelle="Comparer"
            :is-disabled="cantCompare(pageName)"
            :enable-action="!cantCompare(pageName)"
            disabled-tooltip="Pour profiter de cette fonctionnalité, veuillez faire une deuxième évaluation pour les comparer."
            @clickAction="displayCompareCarto('sociopro/' + pageName)"
          />
        </div>
        <!-- END Compare button -->
      </div>

      <div
        v-if="infosPass.id_pass != user.id"
        class="w-full overflow-x-auto"
      >
        <bar
          id-chart="progress"
          title="Axes de progrès"
          orientation="vertical"
          :labels="summaryDatas.labels"
          :values="summaryDatas.values"
          :thickness="10"
          height="200"
          :stacked="true"
          :maintain-aspect-ratio="true"
        />
      </div>

      <div
        v-if="infosPass.id_pass != user.id"
        class="flex space-x-5 mt-5"
      >
        <div
          v-for="(item, j) in summaryDatas.legend"
          :key="j"
          class="flex space-x-2 items-center text-sm"
        >
          <div
            class="w-5 h-5 rounded-full"
            :style="'background-color: ' + item.color + ''"
          />
          <div>{{ item.pageName }}</div>
        </div>
      </div>
    </div>

    <div
      v-else
      class="flex flex-col justify-center items-center w-full"
    >
      <h6 class="text-pink-600 w-full mb-8">
        Aucune donnée
      </h6>
      <div class="text-indigo-600 text-center text-base mb-8">
        {{ infosPass.name }} n'a pas d'évaluation de compétences
        socio-professionnelles
      </div>
      <div>
        <illustration name="no_result" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Icon from '../../../components/Icon';
import ActionButton from '../../../components/ActionButton';
import Radar from '../../../components/Charts/Radar';
import Bar from '../../../components/Charts/Bar.vue';
import Illustration from '../../../components/Illustration';
import PopupCompareCarto from '../../../components/Cartographies/PopupCompareCarto';
import ClickOutside from 'vue-click-outside';
import Constants from './../../../constants';

export default {
  components: {
    Icon,
    ActionButton,
    Radar,
    Illustration,
    PopupCompareCarto,
    Bar,
  },

  name: 'Compsociopro',

  data() {
    return {
      colors: {
        type: 'normal',
        beneficiary: '#21B8C8',
        referent: '#FF1C80',
        true: '#21B8C85A',
        false: '#919AA65A',
      },
      compareCarto: false,
      cartoToCompare: '',
      historyToDisplay: -1,
      toReload: true, //use to hide and show cartography and check changes
      //listCompetencesSocioPro: [],
      currentTemplate: {},
      templateListDisplayed: '',
      constants: Constants,
    };
  },

  created() {
    this.setLastEvaluationTemplates();
  },

  methods: {
    /**
     * Each evaluation has template which can be different
     * Here, we retrieve the template used in the last evaluation to display the right template name in the template dropdown (for each kind of evaluation)
     */
    setLastEvaluationTemplates() {
      this.infosPage.pages.forEach((page) => {
        if (this.templates[page.name]) {
          if (
            this.ongoingEvaluation &&
            this.ongoingEvaluation[page.name]
          ) {
            this.currentTemplate[page.name] = parseInt(
              Object.keys({ ...this.templates[page.name] }).filter(
                (key) =>
                  this.templates[page.name][key] ===
                  this.ongoingEvaluation[page.name].template_name
              )[0]
            );
          } else if (
            ((this.closedEvaluations || {})[page.name] || []).length > 0
          ) {
            this.currentTemplate[page.name] = parseInt(
              Object.keys({ ...this.templates[page.name] }).filter(
                (key) =>
                  this.templates[page.name][key] ==
                  this.closedEvaluations[page.name][
                    this.closedEvaluations[page.name].length - 1
                  ].template_name
              )[0]
            );
          }
        }
      });
    },

    /**
     * display popup to compare a cartography
     * @param String typeCarto
     */
    displayCompareCarto(typeCarto) {
      this.compareCarto = true;
      this.cartoToCompare = typeCarto;
    },

    /**
     * Close popup to compare cartography
     */
    closeCompare() {
      this.compareCarto = false;
      this.cartoToCompare = '';
      this.historyToDisplay = -1;
    },

    /**
     * Change the history cartography to compare
     * @param Number index
     */
    changeCompare(index) {
      setTimeout(() => {
        this.historyToDisplay = -1;
      }, 300);
      setTimeout(() => {
        this.historyToDisplay = index;
      }, 300);
    },

    /**
     * /!\ Method not used for the moment
     * User can choose the cartography colors between old (passeport compétences) or new (neopass) colors
     * @param String n
     */
    switchColor(n) {
      switch (n) {
      case 'normal':
        this.colors.beneficiary = '#21B8C8';
        this.colors.referent = '#FF1C80';
        break;
      case 'old':
        this.colors.beneficiary = '#31AFDE';
        this.colors.referent = '#94AC49';
        break;
      default:
        this.colors.beneficiary = '#21B8C8';
        this.colors.referent = '#FF1C80';
        break;
      }
      this.colors.type = n;
      setTimeout(() => {
        this.toReload = false;
      }, 300);
      setTimeout(() => {
        this.toReload = true;
      }, 300);
    },

    /**
     * Display drop down to choose the template by module name
     * @param String module
     */
    displayTemplateList(module) {
      if (this.templateListDisplayed != module && module != '') {
        this.templateListDisplayed = module;
      }
    },

    /**
     * Close the template choice drop down
     */
    closeTemplateList() {
      if (this.templateListDisplayed != '') {
        this.templateListDisplayed = '';
      }
    },

    /**
     * Change the module template to display cartography
     * @param String type
     * @param Number index
     */
    changeTemplate(type, index) {
      setTimeout(() => {
        this.currentTemplate[type] = -1;
      }, 300);
      setTimeout(() => {
        this.currentTemplate[type] = index;
      }, 300);
      this.closeTemplateList();
    },

    canCompare(page) {
      //TRUE if there are 2 evals in history
      //TRUE if there is 1 eval in history and 1 current eval
      //FALSE otherwise

      let evalCount;
      if (this.closedEvaluations === undefined) {
        evalCount = 0;
      } else {
        evalCount = this.closedEvaluations[page]?.length ?? 0;
      }
      const hasCurrent = this.ongoingEvaluation && this.ongoingEvaluation[page]; //Equivalent to Boolean(this.competencesSocioPro[page])

      return evalCount >= 2 || (evalCount > 0 && hasCurrent);
    },

    cantCompare(page) {
      return !this.canCompare(page);
    },

    shouldBeSplit(carto) {
      return carto.categories.every((cat) => cat.match(/^\d\.\s/));
    },

    getCategories(carto) {
      if (carto.categories.every((cat) => cat.match(/^\d\.\s/))) {
        const sanitized_categories = carto.categories.map((cat) =>
          cat.slice(3)
        );
        const unique_categories = [...new Set(sanitized_categories)];

        const returnValue = [];

        for (const uniqueCategory of unique_categories) {
          let filtered_labels = [];
          let filtered_categories = [];
          let filtered_values = [];
          for (let i = 0; i < sanitized_categories.length; i++) {
            const current_category = sanitized_categories[i];
            if (current_category === uniqueCategory) {
              filtered_labels.push(carto.labels[i]);
              filtered_categories.push(carto.categories[i]);

              for (
                let value_index = 0;
                value_index < carto.values.length;
                value_index++
              ) {
                if (filtered_values[value_index] === undefined) {
                  filtered_values[value_index] = [];
                }
                let current_value = carto.values[value_index];
                filtered_values[value_index].push(current_value.data[i]);
              }
            }
          }

          returnValue.push([
            uniqueCategory,
            {
              ...carto,
              labels: filtered_labels,
              categories: filtered_categories,
              values: carto.values.map((value, index) => {
                return { ...value, data: filtered_values[index] };
              }),
            },
          ]);
        }

        return returnValue;
      } else {
        return [[0, carto]];
      }
    },
  },

  computed: {
    ...mapGetters({
      neopassDatas: 'cartographiesIndividuelles/neopassDatas',
      infosPass: 'cartographiesIndividuelles/infosPass',
      listEvaluations: 'cartographiesIndividuelles/listEvaluations',
      infosPage: 'cartographiesIndividuelles/infosPage',
      user: 'auth/user',
    }),

    ongoingEvaluation: function () {
      if (
        this.neopassDatas &&
        this.neopassDatas[Constants.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO]
      ) {
        return this.neopassDatas[
          Constants.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO
        ];
      }
      return undefined;
    },

    closedEvaluations: function () {
      if (
        this.listEvaluations &&
        this.listEvaluations[
          Constants.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO
        ]
      ) {
        return this.listEvaluations[
          Constants.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO
        ];
      }
      return undefined;
    },

    templates() {
      let list = {};

      this.infosPage.pages.forEach((page) => {
        list[page.name] = [];
      });

      if (this.ongoingEvaluation) {
        for (const [pageName, data] of Object.entries(this.ongoingEvaluation)) {
          if (list[pageName] && data.template_name) {
            list[pageName].push(data.template_name);
          }
        }
      }
      for (const [pageName, evaluations] of Object.entries(
        (this.listEvaluations || {}).compsocio || {}
      )) {
        if (list[pageName]) {
          evaluations.forEach((evaluation) => {
            if (list[pageName] && evaluation.template_name) {
              list[pageName].push(evaluation.template_name);
            }
          });

          list[pageName] = list[pageName].filter(function (value, index, self) {
            return self.indexOf(value) === index;
          });
        }
      }

      return list;
    },

    /**
     * Determine the evaluation to show between current evaluation and last history
     */
    cartograhiesToDisplay() {
      if (this.ongoingEvaluation || this.closedEvaluations) {
        //Verify there is at least one evaluation
        let cartographies = {};

        // Prepare "cartographies" Object variable structure => each key corresponding an evaluation socio pro page
        this.infosPage.pages.forEach((page) => {
          cartographies[page.name] = {};
        });

        // Attribute for each array case the evaluation to display between current or last history
        Object.keys(this.templates)
          .filter((t) => this.templates[t].length > 0)
          .forEach((compSocioName) => {
            if (
              this.ongoingEvaluation &&
              this.ongoingEvaluation[compSocioName] &&
              this.templates[compSocioName][
                this.currentTemplate[compSocioName]
              ] === this.ongoingEvaluation[compSocioName].template_name
            ) {
              cartographies[compSocioName] =
                this.ongoingEvaluation[compSocioName];
            } else if (
              this.closedEvaluations[compSocioName] &&
              this.closedEvaluations[compSocioName].length > 0
            ) {
              let history = this.closedEvaluations[compSocioName].filter(
                (hist) =>
                  hist.template_name ===
                  this.templates[compSocioName][
                    this.currentTemplate[compSocioName]
                  ]
              );
              cartographies[compSocioName] = history[history.length - 1];
            }
          });

        return cartographies;
      } else {
        return null;
      }
    },

    // determine the history choose to compare in popup comparison
    historiesToCompare() {
      let histories = {};

      const entries = Object.entries(this.closedEvaluations);

      for (const [page, listHistories] of entries) {
        histories[page] = [];

        const currentTemplateName =
          this.templates[page][this.currentTemplate[page]];
        const latest = this.cartograhiesToDisplay[page];

        const filteredHistories = listHistories
          .filter((history) => {
            return (
              history.template_name === currentTemplateName &&
              history !== latest
            );
          })
          .sort((a, b) => {
            [a, b] = [new Date(a.date_fin_eval), new Date(b.date_fin_eval)];
            return a < b;
          });

        filteredHistories.forEach((history) => {
          if (this.$subscribed()) {
            histories[page].push(history);
          } else {
            if (histories[page].length < 1) {
              histories[page].push(history);
            }
          }
        });
      }

      return histories;
    },

    // Datas for cartography "Axes de progrès"
    summaryDatas() {
      let datas = {};
      let listColors = [
        '#3211C2',
        '#7B6AFF',
        '#DFE0F2',
        '#FF1C80',
        '#21B8C8',
        '#FF3900',
        '#ABD952',
        '#7BC5F9',
      ];

      let pagesName = Object.keys(this.templates).filter(
        (t) => this.templates[t].length > 0
      );

      datas.values = [
        {
          label: 'Compétences socio-professionnelles',
          data: [],
          backgroundColor: [],
        },
      ];

      datas.labels = [];
      datas.legend = [];

      pagesName.forEach((page, index) => {
        this.cartograhiesToDisplay[page].values[0].data.forEach((val) => {
          datas.values[0].data.push(val);
          datas.values[0].backgroundColor.push(listColors[index]);
        });
        datas.labels = [
          ...datas.labels,
          ...this.cartograhiesToDisplay[page].labels,
        ];

        datas.legend.push({
          pageName: this.templates[page][this.currentTemplate[page]],
          color: listColors[index],
        });
      });

      return datas;
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>
